var React = require('react');

function ChatLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 5a1 1 0 00-1 1v28a1 1 0 001 1h12a1 1 0 011 1v5.586l6.293-6.293A1 1 0 0123 35h22a1 1 0 001-1V6a1 1 0 00-1-1H3zM.879 3.879A3 3 0 013 3h42a3 3 0 013 3v28a3 3 0 01-3 3H23.414l-7.707 7.707A1 1 0 0114 44v-7H3a3 3 0 01-3-3V6a3 3 0 01.879-2.121z"}));
}

ChatLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ChatLight;

ChatLight.default = ChatLight;
